import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ButtonOption, OptionsButton } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  id: number
  canEdit?: boolean
  canDelete: boolean
  onDelete: (id: number) => Promise<void>
  baseNavigationUrl: string
}
export const ReleaseTableOptions = observer((props: Props) => {
  const { id, canEdit = true, canDelete, onDelete, baseNavigationUrl } = props
  const { t } = useTranslate()
  const navigate = useNavigate()
  const { appViewStore } = usePlanningStore()

  const options: ButtonOption[] = [
    {
      label: t('view', 'View'),
      onClick: () => navigate(`${baseNavigationUrl}/${id}/details`),
      testId: 'view-release-option',
    },
  ]

  options.push({
    label: t('edit', 'Edit'),
    disabled: !canEdit,
    onClick: () => navigate(`${baseNavigationUrl}/${id}`),
    testId: 'edit-release-option',
  })

  options.push({
    label: t('delete', 'Delete'),
    disabled: !canDelete,
    onClick: () => {
      handleDelete()
    },
    testId: 'delete-release-option',
  })

  const handleDelete = async () => {
    const isConfirmed = await appViewStore.setOpenConfirmDialog(
      true,
      t(
        'allRelatedInformationWillBeDeletedYoucannotUndoThisAction',
        'All related information will be deleted. You cannot undo this action!',
      ),
      t('deleteRelease', 'Delete release?'),
      undefined,
      {
        primaryActionText: t('yesDelete', 'Yes, delete'),
        secondaryActionText: t('noCancel', 'No, cancel'),
      },
    )

    if (isConfirmed) {
      try {
        await onDelete(id)
      } catch {
        appViewStore.setShowAlert('error', t('failedToDeleted', 'Failed to delete'))
      }
    }
  }

  return (
    <OptionsButton
      tooltip={t('moreOptions', 'More options')}
      options={options}
      position='right'
      testId={'release-three-dot-menu'}
    />
  )
})
